module.exports = __webpack_public_path__ + "img/304-0f96aa.png";